//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Amplitude from "@Shared/@Utils/amplitude";
import ListDetails from "./list-details.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MarketingListDetails",
  components: {
    ListDetails
  },
  props: {
    creating: {
      type: Boolean,
      default: true
    },
    currentList: {
      type: Object,
      required: true
    },
    importContacts: {
      type: Boolean,
      default: true
    },
    fieldsVisibility: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    listId() {
      return this.currentList.listId;
    }
  },
  mounted() {
    Amplitude.logEvent("Lists - details visited");
  },
  methods: {
    getQuery(path, query) {
      const results = new RegExp(`[?&]${query}=([^&#]*)`).exec(path);
      if (results) return results[1];
      return false;
    },
    fromCampaign() {
      return this.getQuery(location.hash, "fromCampaign");
    },
    handleChange(list) {
      this.$emit("change", list);
    }
  }
});